// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3mlxS","headerTitle":"Header_headerTitle__2exrN","menuToggle":"Header_menuToggle__23pHS","alt":"Header_alt__MoySo"};